import {AppModule} from 'api/gen/AppModule';
import {ModuleGuideUrls} from 'api/gen/ModuleGuideUrls';

import {LoadingItemId} from '../types';

/** Shared layout actions for loading indicators, tutorials, and shell preferences. */
export const layoutAction = {
    setItemLoading: (id: LoadingItemId, isLoading: boolean) => ({
        type: 'layout/SET_ITEM_LOADING',
        payload: {id, isLoading},
    }) as const,
    getTutorials: (appModule: AppModule) => ({
        type: 'layout/GET_APP_TUTORIALS',
        payload: {appModule},
    }) as const,
    getTutorialsSuccess: (urls: ModuleGuideUrls | undefined) => ({
        type: 'layout/GET_APP_TUTORIALS_SUCCESS',
        payload: urls,
    }) as const,
    setStatisticalCookie: (enabled: boolean) => ({
        type: 'layout/SET_STATISTICAL_COOKIE',
        payload: enabled,
    }) as const,
};

/** Action used while toggling layout loading indicators. */
export type SetItemLoadingAction = ReturnType<typeof layoutAction.setItemLoading>;
/** Action used to request tutorial URLs for the active module. */
export type GetTutorialsAction = ReturnType<typeof layoutAction.getTutorials>;
/** Action used to store fetched tutorial URLs in layout state. */
export type GetTutorialsSuccessAction = ReturnType<typeof layoutAction.getTutorialsSuccess>;
/** Action used to persist the statistical cookie preference. */
export type SetStatisticalCookieAction = ReturnType<typeof layoutAction.setStatisticalCookie>;

/** Action union for the shared layout reducer and middleware consumers. */
export type LayoutAction =
    | SetItemLoadingAction
    | GetTutorialsAction
    | GetTutorialsSuccessAction
    | SetStatisticalCookieAction
;
